/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  EMPLOYEE_ASSIGN_LIST,
  UNASSIGN_STOCK,
} from "../../../repository/taskRepo";
import useReduxStore from "../../../hooks/useReduxStore";

const useAssignedStock = () => {
  const navigate = useNavigate();
  const { selector: user } = useReduxStore("auth");
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [employeeList, setEmployeeList] = useState([]);
  const [uassignModal, setUnassignModal] = useState(false);
  const [assignedId, setAssignedId] = useState(null);
  const [assignedType, setAssignedType] = useState(null);
  const { agentId } = useParams();
  const location = useLocation();

  const [formData, setFormData] = useState({
    remarks: "",
    quantity: "",
  });

  const handleOpenModal = (id, type, data = {}) => {
    setUnassignModal(true);
    setAssignedId(id);
    setAssignedType(type);
    setFormData((prev) => ({
      ...prev,
      quantity: data?.assignQuantity || "",
    }));
  };
  const handleCloseModal = () => {
    setUnassignModal(false);
    setFormData({});
    setAssignedType(null);
    setAssignedId(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePagination = (obj) => {
    setController(obj);
  };

  useEffect(() => {
    employeeAssignListAPI();
  }, [controller.page, controller.rowsPerPage]);

  const employeeAssignListAPI = async () => {
    try {
      let payload = {
        page: controller.page,
        count: controller.rowsPerPage,
        isDeleted: false,
        isActive: true,
        user_id: agentId || user?.userInfo?._id,
      };

      setSpinner(true);
      let response = await EMPLOYEE_ASSIGN_LIST(payload);
      setEmployeeList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {}
    setSpinner(false);
  };

  const unAssignStock = async () => {
    try {
      let payloadType;
      if (assignedType === "ASSIGN") {
        payloadType = "ASSIGN";
      } else if (assignedType === "USE") {
        payloadType = "USE";
      } else {
        payloadType = assignedType;
      }

      let payload = {
        _id: assignedId,
        type: payloadType,
        remarks: formData.remarks,
        quantity: Number(formData.quantity) || 0,
      };

      setSpinner(true);
      let response = await UNASSIGN_STOCK(payload);
      if (response.code === 200) {
        toast.success(response.message || "Unassigned stock successfully");
        employeeAssignListAPI();
        handleCloseModal();
      } else {
        toast.error(response.message || "Unassign stock fail");
      }
    } catch (error) {
      toast.error(error?.message || "Unassign stock fail");
    } finally {
      setSpinner(false);
    }
  };

  return {
    data: {
      spinner,
      controller,
      totalCount,
      employeeList,
      uassignModal,
      formData,
    },
    methods: {
      handlePagination,
      unAssignStock,
      handleOpenModal,
      handleCloseModal,
      handleChange,
    },
  };
};

export default useAssignedStock;
